import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridAngular } from 'ag-grid-angular';
import { agGridThemes } from '../../../@shared/ag-grid-themes';
import { deriveDynamicColumnDefs } from '../../../@shared/ag-grid-columns';
import { GridCopyMenuComponent } from '../../../@shared/grid-copy-menu/grid-copy-menu.component';
import { CopySourceButtonComponent } from '../../../@shared/copy-source-button/copy-source-button.component';
import {
  TickersMasterService,
  TickersMasterRow,
} from '../../../@services/tickers-master.service';

// Tickers Master pane — read-only AG-Grid over F2-ADMIN.tickers_master
// (Mongo on .133). Columns derived from row shape; nothing hardwired.
@Component({
  standalone: true,
  selector: 'app-tickers-master',
  imports: [AgGridAngular, CommonModule, GridCopyMenuComponent, CopySourceButtonComponent],
  templateUrl: './tickers-master.component.html',
})
export class TickersMasterComponent implements OnInit {
  rows: TickersMasterRow[] = [];
  loading = false;
  loadedAt: string | null = null;
  columnDefs: any[] = [];

  theme = agGridThemes.dark;
  grid: any;

  constructor(private svc: TickersMasterService) {
    this.init_grid();
  }

  async ngOnInit() {
    await this.reload();
  }

  async reload() {
    this.loading = true;
    try {
      this.rows = await this.svc.listAll();
      this.columnDefs = deriveDynamicColumnDefs(this.rows);
      this.loadedAt = new Date().toISOString();
      const api = this.grid?.api;
      if (api?.autoSizeAllColumns) {
        setTimeout(() => api.autoSizeAllColumns(false), 0);
      }
    } finally {
      this.loading = false;
    }
  }

  init_grid() {
    this.grid = {
      options: {
        context: this,
        suppressCellFocus: true,
        rowSelection: {
          mode: 'multiRow',
          checkboxes: true,
          headerCheckbox: true,
          enableClickSelection: false,
        },
        defaultColDef: {
          floatingFilter: true,
          filter: true,
          sortable: true,
          resizable: true,
          cellStyle: { 'text-align': 'left' },
        },
        sideBar: {
          toolPanels: [
            { id: 'columns', labelDefault: 'Columns', labelKey: 'columns', iconKey: 'columns', toolPanel: 'agColumnsToolPanel' },
          ],
        },
        autoSizeStrategy: { type: 'fitCellContents', skipHeader: false },
        onGridReady: (e: any) => { this.grid.api = e.api; },
        onFirstDataRendered: (e: any) => e.api.autoSizeAllColumns(false),
      },
      statusBar: {
        statusPanels: [
          { statusPanel: 'agTotalRowCountComponent', align: 'left' },
          { statusPanel: 'agFilteredRowCountComponent', align: 'left' },
          { statusPanel: 'agSelectedRowCountComponent', align: 'left' },
        ],
      },
    };
  }
}
